export default __webpack_public_path__ + "static/media/clipboardCross.820125c1.svg";